import Flexgrid, { Flexgrid as FlexgridForTests } from './Flexgrid'
// Uncomment the below to migrate to stateful component
// import FlexgridContainer from './FlexgridContainer'

export { Flexgrid, FlexgridForTests }
export default Flexgrid
// Uncomment the below to migrate to stateful component
// export { FlexgridContainer }
// export default { FlexgridContainer }
